__turbopack_context__.v({
  "bottom-amount": "jobs-list-module-scss-module__Kr9gAG__bottom-amount",
  "css-iemeck-container": "jobs-list-module-scss-module__Kr9gAG__css-iemeck-container",
  "css-zapfv0-control": "jobs-list-module-scss-module__Kr9gAG__css-zapfv0-control",
  "mobile-filters-button": "jobs-list-module-scss-module__Kr9gAG__mobile-filters-button",
  "search-results-container": "jobs-list-module-scss-module__Kr9gAG__search-results-container",
  "search-results-sort-container": "jobs-list-module-scss-module__Kr9gAG__search-results-sort-container",
});
